export const CONTACTS_IMPORT_MAX_SIZE_MB = 200;
export const CONTACTS_IMPORT_LIMIT_PER_DAY = 5;
export const CONTACT_IMPORT_TYPE = 'importFileContacts';

export const DEFAULT_SAMPLE_DATA_SIZE = 5;
export const MAX_SAMPLE_DATA_SIZE = 100;

export const SAMPLE_DATA_SIZES = Object.freeze([
    DEFAULT_SAMPLE_DATA_SIZE,
    15,
    25,
    50,
    MAX_SAMPLE_DATA_SIZE,
]);